export enum AttendanceFilterOptionValue {
	FACE_2_FACE = 'face2face',
	ONLINE = 'online',
	BLENDED = 'blended',
}
